import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomFileUpload from 'designer/component/element/FileUpload'

export const FileUploadSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomFileUpload {...props} />
  </DragElementWrapper>
)

export const FileUploadDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomFileUpload {...props} />
  </ElementWrapper>
)

export const fileUploadTester = rankWith(1000, scopeEndsWith('fileUpload'))
